// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3IL_y","dragIcon":"Choice_dragIcon__1gfL6","left":"Choice_left__1NlYf","input":"Choice_input__2_nbq"};